export default function ProgressBar({ current, total, answered }) {
  const pct = Math.round((current / total) * 100);
  return (
    <div className="progress-container">
      <div className="progress-bar-wrap">
        <div className="progress-bar-fill" style={{ width: `${pct}%` }} />
      </div>
      <span className="progress-label">
        Question {current} of {total} &nbsp;|&nbsp; {answered} answered
      </span>
    </div>
  );
}
